const STORAGE_KEY = 'piSchedule.scheduleSharePreview';

export const writeScheduleSharePreviewComposition = (composition) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
        ...composition,
        savedAt: Date.now()
    }));
};

export const readScheduleSharePreviewComposition = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        // Ignore stale previews older than 2 hours
        if (parsed?.savedAt && Date.now() - parsed.savedAt > 2 * 60 * 60 * 1000) {
            localStorage.removeItem(STORAGE_KEY);
            return null;
        }
        return parsed;
    } catch (_) {
        return null;
    }
};

export const clearScheduleSharePreviewComposition = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (_) { /* ignore */ }
};
